import { useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { availableLanguages } from "../../i18nextInit";
import { useTranslation } from "react-i18next";
import { getSignInLink } from "../../utils/path-helper";
import { DomainName } from "../../utils/constants";
import { currentDomain } from "../../utils/general-config";
import { DomainEnum } from "../../services/enum/environment-enum";
import { deleteCookie, deletedomainCookie } from "../../utils/helpers";
import {
  getLegalSimpliBaseURL,
  getPdfSimpliBaseURL,
  getResumeBuildBaseURL,
  getSignSimpliBaseURL,
  getWorksimpliEndPoint,
} from "../../services/api-constants";
import singleSignOnApi from "../../services/single-sign-on-api";

const SignOut = () => {
  const domain = currentDomain().toLowerCase();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const { locale } = useParams();

  const setLocaleURL = (url) => {
    let verifiedLocale = "en";
    if (!!locale) {
      if (availableLanguages.indexOf(locale) > -1) {
        verifiedLocale = locale;
      }
    }
    return url.replace(":locale", verifiedLocale);
  };
  const logout = (locale) => {
    let localeval = "";
    if (!!locale && locale !== "") {
      localeval = locale;
    }
    const cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i];
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;";
      deletedomainCookie(name);
    }
    localStorage.clear();
    deleteCookie("jwtToken");
    deleteCookie("refreshToken");
    deleteCookie("ssoToken");
    deleteCookie("ssoauth");
    deleteCookie("legacyTicket");
    deleteCookie("ssopl");
    deleteCookie("userguid");
    deleteCookie("orgId");
    if (DomainName.RESUMEBUILD === domain) {
      window.location.href = getResumeBuildBaseURL.replace(/\/+$/, "") + getSignInLink(localeval);
    } else if (DomainName.PDFSIMPLI === domain) {
      window.location.href = getPdfSimpliBaseURL.replace(/\/+$/, "") + getSignInLink(localeval);
    } else if (DomainName.SIGNSIMPLI === domain) {
      window.location.href = getSignSimpliBaseURL.replace(/\/+$/, "") + getSignInLink(localeval);
    } else if (DomainName.LEGALSIMPLI === domain) {
      window.location.href = getLegalSimpliBaseURL.replace(/\/+$/, "") + getSignInLink(localeval);
    } else if (DomainName.WORKSIMPLI === domain) {
      singleSignOnApi.partnerLogOut("WKSM").then((response) => {
        window.location.href = getWorksimpliEndPoint.replace(/\/+$/, "") + getSignInLink(localeval);
      }).catch((error) => {
        console.log(error);
        window.location.href = getWorksimpliEndPoint.replace(/\/+$/, "") + getSignInLink(localeval);
      })
    }
  };
  useEffect(() => {
    logout(locale);
  }, []);

  return (
    <>
      {() => {
        const domain = currentDomain().toLowerCase();
        switch (domain) {
          case DomainEnum.PDFSIMPLI:
            return (
              <div className="displaymobile" style={{ marginLeft: "144px" }}>
                <img
                  className="rb-logo height-37 my-4 ps-20"
                  src={process.env.PUBLIC_URL + "/static/images/pdfsimpli-logo.svg"}
                  width="117"
                  alt="pdfsimpli"
                  draggable="false"
                />
                <section className="section main-content text-center">
                  <div className="container intro">
                    <div className="row">
                      <div className="col-12 headline-group">
                        <hgroup>
                          <h2>{t("generic_error.please_wait")}</h2>
                        </hgroup>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            );
          case DomainEnum.LEGALSIMPLI:
            return (
              <div className="displaymobile" style={{ marginLeft: "144px" }}>
                <img
                  className="rb-logo height-37 my-4 ps-20"
                  src={process.env.PUBLIC_URL + "/static/images/legalsimpli-logo.svg"}
                  width="117"
                  alt="legalsimpli"
                  draggable="false"
                />
                <section className="section main-content text-center">
                  <div className="container intro">
                    <div className="row">
                      <div className="col-12 headline-group">
                        <hgroup>
                          <h2>{t("generic_error.please_wait")}</h2>
                        </hgroup>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            );
          case DomainEnum.SIGNSIMPLI:
            return (
              <div className="displaymobile" style={{ marginLeft: "144px" }}>
                <img
                  className="rb-logo height-37 my-4 ps-20"
                  src={process.env.PUBLIC_URL + "/static/images/signsimpli-logo.svg"}
                  width="117"
                  alt="signsimpli"
                  draggable="false"
                />
                <section className="section main-content text-center">
                  <div className="container intro">
                    <div className="row">
                      <div className="col-12 headline-group">
                        <hgroup>
                          <h2>{t("generic_error.please_wait")}</h2>
                        </hgroup>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            );
          default:
          case DomainEnum.RESUMEBUILD:
            return (
              <div className="displaymobile" style={{ marginLeft: "144px" }}>
                <img
                  className="rb-logo height-37 my-4 ps-20"
                  src={process.env.PUBLIC_URL + "/static/images/resumebuild-logo.svg"}
                  width="117"
                  alt="resumebuild"
                  draggable="false"
                />
                <section className="section main-content text-center">
                  <div className="container intro">
                    <div className="row">
                      <div className="col-12 headline-group">
                        <hgroup>
                          <h2>{t("generic_error.please_wait")}</h2>
                        </hgroup>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            );
        }
      }}
    </>
  );
};

export default SignOut;
